<script lang="ts" setup>import { toRef as _toRef } from 'vue';

import { VueRecaptcha } from 'vue-recaptcha'
import { giftCodeLookup } from '@consumer/services/api/recipientGift'
import { useRecaptcha } from '@consumer/composables/sharedData'

const orderNumber = ref('')

const errorMessage = ref<string | null>(null)

const onSubmit = () => {
  errorMessage.value = null
  giftCodeLookup(orderNumber.value, recaptchaToken.value!).then((data) => {
    window.location.href = data.redirectUrl
  }).catch((error) => {
    errorMessage.value = error.message
    orderNumber.value = ''
    recaptcha.value?.reset()
  })
}

const __$temp_1 = (useRecaptcha()),
  recaptchaCheckboxSiteKey = _toRef(__$temp_1, 'recaptchaCheckboxSiteKey');

const recaptchaToken = ref<string>()

const recaptchaVerify = (response: string) => {
  recaptchaToken.value = response
}

const recaptchaExpired = () => {
  recaptchaToken.value = undefined
}

const recaptcha = ref<InstanceType<typeof VueRecaptcha>>()
</script>

<template>
  <form
    class="mt-6"
    @submit.prevent="onSubmit"
  >
    <div class="flex flex-col gap-6 w-72">
      <div class="w-full">
        <GTextInput
          v-model="orderNumber"
          label="Enter the activation code"
          placeholder="Ex.: acthfw"
        />
      </div>
      <div class="w-full">
        <VueRecaptcha
          ref="recaptcha"
          :sitekey="recaptchaCheckboxSiteKey"
          @verify="recaptchaVerify"
          @expired="recaptchaExpired"
        />
      </div>
      <div class="w-full">
        <GButton
          primary
          size="large"
          name="find-order-button"
          label="Next"
          type="submit"
        />
      </div>
    </div>
    <div v-if="errorMessage" class="text-red-base mt-4">
      {{ errorMessage }}
    </div>
  </form>
</template>
